<template>
  <div>
    <i-button-group size="small">
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_sent`)"
        @click="onClickSummaryFilter(`${shopId}_${summaryData.cd}_sent`, summaryData, 'sent')"
      >
        掲載中
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_sending_reservation`)"
        @click="
          onClickSummaryFilter(`${shopId}_${summaryData.cd}_sending_reservation`, summaryData, 'sending_reservation')
        "
      >
        送信予約
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_expired`)"
        @click="onClickSummaryFilter(`${shopId}_${summaryData.cd}_expired`, summaryData, 'expired')"
      >
        期限切れ
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_deleting_reservation`)"
        @click="
          onClickSummaryFilter(`${shopId}_${summaryData.cd}_deleting_reservation`, summaryData, 'deleting_reservation')
        "
      >
        削除予約
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_deleted`)"
        @click="onClickSummaryFilter(`${shopId}_${summaryData.cd}_deleted`, summaryData, 'deleted')"
      >
        削除済み
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_due_today`)"
        @click="onClickSummaryFilter(`${shopId}_${summaryData.cd}_due_today`, summaryData, 'due_today')"
      >
        期限本日
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_not_posted`)"
        @click="onClickSummaryFilter(`${shopId}_${summaryData.cd}_not_posted`, summaryData, 'not_posted')"
      >
        未掲載
      </i-button>
      <i-button
        type="primary"
        :ghost="activePrimary(`${shopId}_${summaryData.cd}_posting_not_possible`)"
        @click="
          onClickSummaryFilter(`${shopId}_${summaryData.cd}_posting_not_possible`, summaryData, 'posting_not_possible')
        "
      >
        掲載不可
      </i-button>
    </i-button-group>
  </div>
</template>

<script>
import SummarySearchText from '@/mixins/summary_search_text'
import { ButtonGroup, Button } from 'view-design'

export default {
  mixins: [SummarySearchText],
  components: {
    'i-button-group': ButtonGroup,
    'i-button': Button,
  },
  props: {
    summaryData: {
      type: Object,
      default: () => {},
      required: true,
    },
    shopId: {
      type: Number,
      default: null,
      required: true,
    },
    summary: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    selectSummary() {
      return this.$store.getters['ConvertSummary/getSelectSummary']
    },
  },
  data() {
    return {}
  },
  methods: {
    // ボタンのアクティブ判定
    activePrimary(val) {
      let select = this.selectSummary[val]
      return select && select === 1 ? false : true
    },
    // ボタンがクリックされた場合、ステータスを変更する
    onClickSummaryFilter(val, summaryData, type) {
      let data = {}
      data.shop_id = this.shopId
      data.type = type
      data.cd = summaryData.cd
      if (this.selectSummary[val]) {
        this.search.summary = _.reject(this.search.summary, data)
        this.$set(this.selectSummary, val, 0)
      } else {
        this.search.summary.push(data)
        this.$set(this.selectSummary, val, 1)
      }

      // サマリー検索テキストを生成する
      this.summarySearchText(this.shopId)
    },
  },
}
</script>

<style lang="scss" scoped></style>
